// 支付
const payOrder = () => import('@/pages/payment/payOrder.vue');
const cashier = () => import('@/pages/payment/cashier.vue');
const paySuccess = () => import('@/pages/payment/paySuccess.vue');
const payAgreement = () => import('@/pages/payment/agreement/payAgreement.vue');
export default [
  {
    path: '/payOrder',
    name: 'payOrder',
    component: payOrder,
    meta: {
      title: '确认订单',
      requireAuth: true,
    },
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: cashier,
    meta: {
      title: '收银台',
      requireAuth: true,
    },
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: paySuccess,
    meta: {
      title: '支付成功',
      requireAuth: true,
    },
  },
  {
    path: '/payAgreement',
    name: 'payAgreement',
    component: payAgreement,
    meta: {
      title: '购课协议',
    },
  },
];
